import Badge from 'components/base/Badge';
import { currencyFormat } from 'helpers/utils';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import { formatDate } from 'services/utils';
import UpiIcon from 'assets/img/icon/UPI-Color.png';
import UpiIconDark from 'assets/img/icon/UPI-Color-dark.png';
import Icon from 'components/icon';
import {
  getDriverConfirmationStatus,
  getPaymentStatus
} from 'helpers/status-badge';
import Button from 'components/base/Button';
import { ChallanPrintButton } from 'views/operation/Challan/ChallanPrint';
import { masterPaths } from 'constants/pagePath';

const paymentInitiatedColumns = (
  handlePayWithCash,
  handleOpenDetail,
  handleReceivePod,
  handleLoading,
  handleRetrievePayment,
  handleDriverPreview,
  abilities
) => [
  {
    accessorKey: 'challan_no',
    header: 'Challan No.',
    cell: ({ row: { original } }) => {
      const { challan_no } = original;
      return (
        <Badge
          className="fs-9 cursor-pointer"
          onClick={() => handleOpenDetail(original)}
          variant="tag"
        >
          #{challan_no}
        </Badge>
      );
    },
    meta: {
      headerProps: { className: 'pe-3 ps-0' },
      cellProps: { className: 'ps-0' }
    }
  },
  {
    accessorKey: 'trucker_name',
    header: 'Trucker Name',
    cell: ({ row: { original } }) => {
      const { trucker_name } = original;
      return (
        <Link
          to={`${masterPaths.vehicle.list}?search=${trucker_name}`}
          className="fw-medium"
        >
          {trucker_name}
        </Link>
      );
    },
    meta: {
      headerProps: {
        style: { width: '15%' },
        className: 'pe-3 ps-0'
      },
      cellProps: { className: 'ps-0' }
    }
  },

  {
    accessorKey: 'vehicle_number',
    header: 'Vehicle No.',
    cell: ({ row: { original } }) => {
      const { vehicle_number } = original;
      return (
        <Link
          to={`${masterPaths.vehicle.list}?search=${vehicle_number}`}
          className="fw-medium"
        >
          #{vehicle_number}
        </Link>
      );
    },
    meta: {
      headerProps: { className: 'pe-3 ps-0' },
      cellProps: { className: 'ps-0' }
    }
  },
  {
    accessorKey: 'created_date',
    header: 'Date',
    cell: ({ row: { original } }) => {
      const { created_date } = original;
      return (
        <div>
          <p className="mb-0 fs-9">{formatDate(created_date, 'DD MMM YYYY')}</p>
          <p className="mb-0 fs-9">{formatDate(created_date, 'hh:mm A')}</p>
        </div>
      );
    },
    meta: {
      headerProps: { className: 'text-start' },
      cellProps: {
        className: 'text-700 ps-2 text-start white-space-nowrap'
      }
    }
  },
  {
    id: 'driver_name',
    accessorKey: 'driver_name',
    header: 'Driver Name',
    cell: ({ row: { original } }) => {
      const { driver_name, driver_mobile } = original;
      return (
        <div>
          <Button
            variant="link"
            onClick={() => handleDriverPreview(original)}
            className="fs-8 fw-bold p-0"
          >
            {driver_name}
          </Button>
          <div>
            <Link className="text-700" to={`tel:${driver_mobile}`}>
              {driver_mobile || '--'}
            </Link>
          </div>
        </div>
      );
    },
    meta: {
      cellProps: { className: ' white-space-nowrap' }
    }
  },
  // {
  //   accessorKey: 'driver_mobile',
  //   header: 'Mobile'
  // },
  {
    accessorKey: 'driver_upi_id',
    header: 'UPI',

    cell: ({ row: { original } }) =>
      original.driver_upi_id ? (
        <>
          <p className="m-0">{original.driver_upi_id}</p>
          <p className="fs-10 mb-0">{original.driver_upi_name || ''}</p>
        </>
      ) : (
        '--'
      ),
    meta: {
      headerProps: {
        style: { width: '15%' },
        className: 'ps-3 pe-4 '
      },
      cellProps: {
        className: 'white-space-nowrap ps-3  '
      }
    }
  },
  {
    id: 'trans_type',
    accessorKey: 'trans_type',
    header: 'Mode',
    cell: ({ row: { original } }) => {
      const { trans_type } = original;
      return (
        <>
          {trans_type === 'Upi' ? (
            <>
              <img
                className="d-dark-none"
                src={UpiIcon}
                width={'40px'}
                height={'20px'}
                alt="upi icon"
              />
              <img
                className="d-light-none"
                src={UpiIconDark}
                width={'40px'}
                height={'20px'}
                alt="upi icon"
              />
            </>
          ) : (
            <Badge
              bg={'primary'}
              variant="pill"
              iconPosition="end"
              className="fs-9 font-outfit"
            >
              {/* {trans_type} */}
              Cash
            </Badge>
          )}
        </>
      );
    },
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: {
        className: 'text-center'
      }
    }
  },
  {
    id: 'trans_status',
    accessorKey: 'trans_status',
    // accessorFn: ({ payment_status }) => payment_status.label,
    header: 'Payment status',
    cell: ({ row: { original } }) => {
      const { trans_status } = original;
      const badgeDetail = getPaymentStatus(trans_status);
      return (
        <div className="d-flex flex-column align-items-center">
          <Badge
            bg={badgeDetail.color}
            variant="phoenix"
            iconPosition="end"
            className="fs-10 font-outfit w-max-content"
            icon={
              <FeatherIcon
                icon={badgeDetail.icon}
                size={12.8}
                className="ms-1"
              />
            }
          >
            {badgeDetail.label || trans_status}
          </Badge>
          {trans_status === 'Failed' ? (
            <>
              <Button
                // disabled
                variant="link"
                startIcon={
                  <Icon
                    fontSize="12px"
                    icon={'streamline:information-circle'}
                  />
                }
                size="sm"
                onClick={() => handlePayWithCash(original)}
                className="mt-1 p-0 pt-0 px-1 fs-9 fw-normal w-max-content"
              >
                Pay via cash?
              </Button>

              <Button
                // disabled
                variant="link"
                startIcon={
                  <Icon
                    fontSize="12px"
                    icon={'streamline:information-circle'}
                  />
                }
                size="sm"
                onClick={() => handleRetrievePayment(original)}
                className="mt-1 p-0 pt-0 px-1 fs-9 fw-normal w-max-content"
              >
                Retrieve Payment?
              </Button>
            </>
          ) : (
            ''
          )}
        </div>
      );
    },
    meta: {
      headerProps: { className: 'pe-3 text-center' },
      cellProps: {
        className: 'text-center'
      }
    }
  },
  {
    id: 'driver_confirmation',
    accessorKey: 'driver_confirmation',
    // accessorFn: ({ payment_status }) => payment_status.label,
    header: 'Driver Confirmation',
    cell: ({ row: { original } }) => {
      const { driver_confirmation } = original;
      const badgeDetail = getDriverConfirmationStatus(driver_confirmation);
      return (
        <Badge
          bg={badgeDetail.color}
          variant="phoenix"
          iconPosition="end"
          className="fs-10 font-outfit"
          icon={
            <FeatherIcon icon={badgeDetail.icon} size={12.8} className="ms-1" />
          }
        >
          {badgeDetail.label || driver_confirmation}
        </Badge>
      );
    },
    meta: {
      headerProps: { className: 'pe-3 text-center' },
      cellProps: {
        className: 'text-center'
      }
    }
  },
  {
    accessorKey: 'driver_advance',
    header: 'Amount',
    cell: ({ row: { original } }) => (
      <Badge
        bg="primary"
        className="fs-8 font-outfit fw-normal"
        variant="phoenix"
      >
        {currencyFormat(original.driver_advance)}
      </Badge>
    ),
    meta: {
      headerProps: { style: { width: '6%' }, className: 'text-center' },
      cellProps: { className: 'text-center fw-semi-bold text-1000' }
    }
  },
  {
    accessorKey: 'challan_no ',
    header: 'Print',
    cell: ({ row: { original } }) => (
      <ChallanPrintButton
        id={original.challan_id}
        handleLoading={handleLoading}
      />
    ),
    meta: {
      headerProps: {
        // style: { width: '15%' },
        className: 'ps-3 pe-4 '
      },
      cellProps: {
        className: 'white-space-nowrap ps-3  '
      }
    }
  },
  {
    header: 'Action',
    id: 'action',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cell: ({ row: { original } }) => (
      <div className="">
        <Button
          variant="phoenix-primary"
          className="white-space-nowrap px-2 py-1 fs-9 font-outfit fw-normal mb-1"
          size="sm"
          onClick={() => handleReceivePod(original)}
          endIcon={<Icon icon={''} fontSize={'14px'} />}
          disabled={
            original.pod_status === 'Received' ||
            !abilities.can('maker', 'Coal/Iron Ore POD')
          }
        >
          {/* {original.pod_status === 'Pending' ? 'Receive POD' : 'POD Received'} */}
          {original?.pod_status == 'Received' ? 'Received' : 'Receive POD'}
        </Button>
      </div>
    ),
    meta: {
      headerProps: { className: 'text-center ps-4 font-outfit' },
      cellProps: { className: 'text-center ps-4' }
    }
  }
];

export default paymentInitiatedColumns;
